// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

/**
 * AlarmGroupDeleteDialog - Dialog for confirming alarm group deletion
 *
 * Displays configuration details and requires confirmation before deletion.
 */
const DeleteAlarmConfigurationDialog = ({
  open = false,
  configurationToDelete,
  alarmTypes = [],
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('alarms');

  if (!configurationToDelete) return null;

  console.log('Alarm Types in Delete Dialog:', alarmTypes);

  return (
    <Dialog open={Boolean(open)} onClose={onCancel}>
      <DialogTitle>
        {t('dialog.delete_alarm_configuration_title', {
          defaultValue: 'Delete alarm configuration',
        })}
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          {t('dialog.confirm_delete_config', {
            defaultValue:
              'Are you sure you want to delete this alarm configuration? This action cannot be undone.',
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {t('dialog.cancel', {
            defaultValue: 'Cancel',
          })}
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm}>
          {t('dialog.delete', {
            defaultValue: 'Delete',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAlarmConfigurationDialog;
